// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "vendors" + "-" + "d98e90abab7cdd16c6c1" + ".css";
};